
module.exports = {
    builtinPlugins: {
        'animations': require('./animations'),
'behavior': require('./behavior'),
'blockUpdates': require('./blockUpdates'),
'blocks': require('./blocks'),
'books': require('./books'),
'channels': require('./channels'),
'chat': require('./chat'),
'chest': require('./chest'),
'commandBlocks': require('./commandBlocks'),
'commands': require('./commands'),
'communication': require('./communication'),
'crafting': require('./crafting'),
'daycycle': require('./daycycle'),
'digging': require('./digging'),
'dimensionCodec': require('./dimensionCodec'),
'effects': require('./effects'),
'entities': require('./entities'),
'errorHandler': require('./errorHandler'),
'experience': require('./experience'),
'external': require('./external'),
'fallDamange': require('./fallDamange'),
'gamerules': require('./gamerules'),
'header': require('./header'),
'health': require('./health'),
'index': require('./index'),
'inventory': require('./inventory'),
'log': require('./log'),
'login': require('./login'),
'logout': require('./logout'),
'moderation': require('./moderation'),
'particle': require('./particle'),
'physics': require('./physics'),
'placeBlock': require('./placeBlock'),
'players': require('./players'),
'pluginsFolder': require('./pluginsFolder'),
'portal': require('./portal'),
'pvp': require('./pvp'),
'redstone': require('./redstone'),
'respawn': require('./respawn'),
'settings': require('./settings'),
'signs': require('./signs'),
'sound': require('./sound'),
'spawn': require('./spawn'),
'stats': require('./stats'),
'tabComplete': require('./tabComplete'),
'tick': require('./tick'),
'tp': require('./tp'),
'updatePositions': require('./updatePositions'),
'useItem': require('./useItem'),
'warps': require('./warps'),
'weather': require('./weather'),
'world': require('./world')
    }
}
